import http from "./httpService";

export function getVendors() {
  return http.get("/vendors");
}